/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
import { useDispatch, useSelector } from 'react-redux';
import { selectCartDataLoaded, selectError, selectHideErrorModal } from 'cart-ui-react/src/autoshipState/selectors';
import { setError } from 'cart-ui-react/src/autoshipState/autoshipSlice';
import Xbutton from './Xbutton';
import t from '@rcm/i18n-client';

const ErrorPopup = () => {
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const hideModal = useSelector(selectHideErrorModal);
  const cartDataLoaded = useSelector(selectCartDataLoaded);

  const handleOkay = () => {
    dispatch(setError(''));
    localStorage.removeItem('paymentError');
  };

  return cartDataLoaded && error && !hideModal ? (
    <div
      css={{
        backgroundColor: '#ffbebc',
        color: 'red',
        width: '100%',
        minHeight: '50px',
        border: '1px solid #FF1205',
        borderRadius: '4px',
        margin: '16px auto 0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
        padding: '0 4px',
        ['p']: { margin: 0, whiteSpace: 'pre-wrap' },
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 'auto',
          width: '-webkit-fill-available',
          padding: '20px',
          position: 'sticky',
          top: 0,
        }}
      >
        <p>{t('The following error occurred')}:</p>
        <p css={{ color: 'black' }}>{t(error)}</p>
        <p css={{ fontSize: '14px' }}>
          {t('If the issue persists, please contact customer support')}.
        </p>
      </div>
      <Xbutton sx={{ width: '22px' }} onClick={handleOkay} />
    </div>
  ) : null;
};

export default ErrorPopup;
